import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(val, id) {
    const response = await api.fetch(`/api/v2/booking/confirm`, {
      method: 'POST',
      body: JSON.stringify({
        import: val,
        id_integration: id,
      }),
    })
    return await handleResponse(response)
  }
}
